/**
 * SparkleIcon — issue #438 visual system. Single icon in the brand
 * palette (currentColor stroke, 2px line, rounded caps). Tree-shakable
 * via direct import path:
 *
 *   import { SparkleIcon } from './icons/SparkleIcon';
 *
 * Accepts `size` (default 20) and `className`. Omit `aria-label` to
 * mark the icon as decorative (`aria-hidden="true"` by default); supply
 * `aria-label` to render as a labelled image with `role="img"`.
 */
import type { ReactElement } from 'react';
import type { IconProps } from './iconTypes';
import { SHARED_ICON_ATTRS } from './iconTypes';

export function SparkleIcon({ size = 20, className, ...rest }: IconProps): ReactElement {
  const aria = rest['aria-label']
    ? { role: 'img' as const, 'aria-label': rest['aria-label'] }
    : { 'aria-hidden': true };
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      {...SHARED_ICON_ATTRS}
      {...aria}
      {...className ? { className } : undefined}
      {...rest}
    >
      <path d="M12 3v3" />
      <path d="M12 18v3" />
      <path d="M5 12H2" />
      <path d="M22 12h-3" />
      <path d="M6.34 6.34l-2.12-2.12" />
      <path d="M19.78 19.78l-2.12-2.12" />
      <path d="M6.34 17.66l-2.12 2.12" />
      <path d="M19.78 4.22l-2.12 2.12" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}
